"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderTrack = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const SliderTrack = ({ fillClassName, leaveSpaceAtEnd, leaveSpaceAtStart, roundEnd = false, roundStart = false, slider, trackEnd, trackStart }) => {
    const length = slider.max - slider.min;
    const left = react_1.default.useCallback(({ sizes }) => {
        if (leaveSpaceAtStart) {
            return `calc(${((trackStart - slider.min) / length) * 100}% + ${sizes[1] + sizes[1] / 2}px)`;
        }
        else {
            return `${((trackStart - slider.min) / length) * 100}%`;
        }
    }, [leaveSpaceAtStart, length, slider, trackStart]);
    const width = react_1.default.useCallback(({ sizes }) => {
        const trackLength = trackEnd - trackStart;
        if (leaveSpaceAtEnd && leaveSpaceAtStart) {
            return `calc(${(trackLength / length) * 100}cqw - ${sizes[3]}px)`;
        }
        else if (leaveSpaceAtEnd || leaveSpaceAtStart) {
            return `calc(${(trackLength / length) * 100}cqw - ${sizes[1] + sizes[1] / 2}px)`;
        }
        else {
            return `${(trackLength / length) * 100}cqw`;
        }
    }, [leaveSpaceAtEnd, leaveSpaceAtStart, length, trackEnd, trackStart]);
    return (react_1.default.createElement(foundations_1.Box, { as: "span", className: fillClassName, sx: {
            backgroundColor: fillClassName
                ? undefined
                : "slider-surface-not-selected",
            borderEndEndRadius: roundEnd ? "radius-1" : null,
            borderEndStartRadius: roundStart ? "radius-1" : null,
            borderStartEndRadius: roundEnd ? "radius-1" : null,
            borderStartStartRadius: roundStart ? "radius-1" : null,
            display: "block",
            height: 2,
            left,
            position: "absolute",
            top: 3,
            width
        } }));
};
exports.SliderTrack = SliderTrack;
//# sourceMappingURL=SliderTrack.js.map